export var AnalyticsEventType;
(function (AnalyticsEventType) {
    AnalyticsEventType["PageView"] = "page_view";
    AnalyticsEventType["Started"] = "started";
    AnalyticsEventType["LanguageChange"] = "language_change";
    AnalyticsEventType["MatterTypes"] = "matter_types";
    AnalyticsEventType["QuestionsViewed"] = "questions_viewed";
    AnalyticsEventType["RemovedQuestion"] = "removed_question";
    AnalyticsEventType["AddedQuestion"] = "added_question";
    AnalyticsEventType["ViewForm"] = "view_form";
    AnalyticsEventType["SubmitForm"] = "submit_form";
    AnalyticsEventType["Variant"] = "variant";
    AnalyticsEventType["ViewExtendedForm"] = "view_extended_form";
    AnalyticsEventType["SubmitExtendedForm"] = "submit_extended_form";
    AnalyticsEventType["ViewReport"] = "view_report";
    AnalyticsEventType["DownloadReport"] = "download_report";
    AnalyticsEventType["SignedUp"] = "signed_up";
    AnalyticsEventType["VerifiedReport"] = "verified_report";
})(AnalyticsEventType || (AnalyticsEventType = {}));
;
//# sourceMappingURL=analytics.js.map